import * as angular from "angular";
import {IController} from "angular";

export class ImagesViewerComponent implements IController {

  attachments: { id: string, name: string, url: string, purpose?: string }[]
  height: any;

  public currentViewedAttachment: { id: string, name: string, url: string, purpose?: string };
  public currentViewedAttachmentIndex: number;
  public totalImages: number;
  public canUpload: boolean;
  public pattern = "'.pdf,.tif,.tiff,.bmp,.jpeg,.jpg,.gif,.png,.eps,.raw,.cr2,.nef,.orf,.sr2'"

  constructor() {

  }

  $onInit() {

    this.currentViewedAttachment = this.attachments[0];
    if (this?.attachments?.length) {
      this.currentViewedAttachmentIndex = 0;
    }
    this.totalImages = this?.attachments.length;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.stepAttachments && !changes.stepAttachments.isFirstChange()) {
      this.$onInit();
    }
  }

  nextImage() {
    const nextIndex = (this.currentViewedAttachmentIndex + 1) === this?.attachments.length ? 0 : this.currentViewedAttachmentIndex + 1;
    this.currentViewedAttachment = this?.attachments[nextIndex];
    this.currentViewedAttachmentIndex = nextIndex;
  }

  previousImage() {
    const nextIndex = this.currentViewedAttachmentIndex ? this.currentViewedAttachmentIndex - 1 : this?.attachments.length - 1;
    this.currentViewedAttachment = this?.attachments[nextIndex];
    this.currentViewedAttachmentIndex = nextIndex;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('imagesViewer', {
    bindings: {
      attachments: '<',
      // height: '<?',
    },
    template: require('./images-viewer.html').default,
    controller: ImagesViewerComponent
  });
